import { render, staticRenderFns } from "./KnowledgeContentTally.vue?vue&type=template&id=cb372d6c&"
import script from "./KnowledgeContentTally.vue?vue&type=script&lang=js&"
export * from "./KnowledgeContentTally.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports